import { FC } from 'react';

export type AlignRightIconProps = {};

export const AlignRightIcon: FC<AlignRightIconProps> = ({}) => (
  <svg fill="none" height="16" viewBox="0 0 16 16" width="16" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M5.33333 6.66667H14M2.66667 4H14M2.66667 9.33333H14M5.33333 12H14"
      stroke="#475467"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.33333"
    />
  </svg>
);
